<template>
  <div class="desktop-crumb">
    <span
      v-for="(bc, i) in parentCrumbs"
      :key="i"
      class="c-breadcrumb"
    >
      <NuxtLink
        data-test="bc-label"
        class="label"
        :class="{ 'cursor-pointer': props.hasCustomLinkBehavior }"
        :to="props.hasCustomLinkBehavior ? undefined : to(bc.slug)"
        @click.stop.prevent="onClick(bc.slug)"
      >
        {{ bc.name }}
      </NuxtLink>
      <CIcon
        name="chevron_right"
        class="icon-forward"
      />
      <p class="alternative-icon-forward">/</p>
    </span>
    <span
      v-if="breadcrumb.name"
      class="c-breadcrumb"
    >
      <span
        data-test="bc-label"
        class="label"
      >
        {{ breadcrumb.name }}
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CIcon from '../../../atoms/CIcon'
import { FullPathBreadcrumbProps } from './FullPathBreadcrumb.props'

const props = withDefaults(defineProps<FullPathBreadcrumbProps>(), {
  breadcrumb: () => ({
    name: undefined,
    parents: [],
  }),
  showStart: true,
  hasCustomLinkBehavior: false,
})

const emit = defineEmits<{
  (e: 'click', slug?: string): void
}>()

const parentCrumbs = computed(() =>
  props.showStart
    ? [{ name: 'Start' }, ...(props.breadcrumb.parents as BreadcrumbParent[])]
    : props.breadcrumb.parents,
)

const onClick = (slug?: string) => {
  if (props.hasCustomLinkBehavior) {
    emit('click', slug)
  }
}
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import { BreadcrumbParent } from '../CBreadcrumbs.props'

export default defineComponent({
  name: 'FullPathBreadcrumb',
})
</script>
